export default {
  TOGGLE_TIMELINE: 'TOGGLE_TIMELINE',
  SET_STATUS_HEADER_HEIGHT: 'SET_STATUS_HEADER_HEIGHT',
  RESET_STATUS_HEADER: 'RESET_STATUS_HEADER',
  SWITCH_DOSSIER_FAVORITE: 'SWITCH_DOSSIER_FAVORITE',
  SWITCH_DOSSIER_FAVORITE_SUCCESS: 'SWITCH_DOSSIER_FAVORITE_SUCCESS'
}
